import React, { useRef } from 'react';
import CreateIcon from '@material-ui/icons/Create';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import { GiCardExchange } from "react-icons/gi";
import CalendarViewDayIcon from '@material-ui/icons/CalendarViewDay';
import { makeStyles } from '@material-ui/core/styles';
import { ListItem, Tooltip, Grid, Paper } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    seeMore: {
        marginTop: theme.spacing(3),
    },
    box: {
        display: "flex",
    },
    spreadBox: {
        justifyContent: "space-between",
        alignItems: "center"
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 320,
    },
    tableAction: {
        paddingLeft: 0,
        paddingRight: 0,
        margin: "0 auto",
        textAlign: "center",
        alignItems: "center"
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '600px',
        margin: 'auto'

    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        borderRadius: '10px'
    },
    paperContent: {
        backgroundColor: process.env.REACT_APP_PRIMARY_THEMA,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(1, 1, 1),
        borderRadius: '10px'
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    card: {
        padding: theme.spacing(3),
        marginBottom: theme.spacing(2),
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        height: 'auto',
        marginTop: '-1%',
        marginBottom: '1.5%'
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
    },
    cardActions: {
        display: 'flex',
        justifyContent: 'space-between',
    },
}));


export default function ListUsersGeneral({ primaryColor, changeRol, rows, isLoadUser, page, size, changeStatus, totalElements, setPage, openModalEdit, changeMachine }) {
    const tooltipRef = useRef(null);

    const r = Array.isArray(rows) ? rows.sort((a, b) => a.ies < b.ies ? 1 : -1) : [];
    const clases = useStyles()

    return (
        <>

            {isLoadUser ? <>cargando...</> : r.map((row) => (
                <Paper
                    key={row.id} className={clases.card}>
                    <Grid container spacing={1}>
                        <Grid item style={{ width: '18.5%', paddingLeft: '1%', fontWeight: "bold", fontSize: '16px' }}>
                            {row.name}
                        </Grid>
                        <Grid item style={{ width: '22%', paddingLeft: '0%', fontWeight: "bold", fontSize: '16px', wordWrap: 'break-word' }}>
                            {row.email}
                        </Grid>
                        <Grid style={{ width: '20%', paddingLeft: '6.5%', fontWeight: "bold", fontSize: '16px' }}>
                            {row.roles[0].name}
                        </Grid>
                        <Grid style={{ width: '15%', paddingLeft: '7%', fontWeight: "bold", fontSize: '16px' }}>
                            {row.status != false ? 'Activo' : 'Inactivo'}
                        </Grid>
                        <Grid style={{ width: '6%', paddingLeft: '0%' }} onClick={() => { openModalEdit(row) }} setId={row}>
                            <ListItem button >
                                <Tooltip title="Editar" aria-label="right-end" ref={tooltipRef}>
                                    <div>
                                        <CreateIcon color="primary" style={{ marginLeft: '15%' }} />
                                    </div>
                                </Tooltip>
                            </ListItem>
                        </Grid>
                        <Grid style={{ width: '6%', paddingLeft: '0%' }} onClick={() => { changeStatus(row) }}>
                            <ListItem button >
                                <Tooltip title={row.status ? "Inhabilitar" : "Habilitar"} aria-label="right-end" ref={tooltipRef}>
                                    <div>
                                        {row.status == !"activo" ? <CheckCircleOutlineIcon color="primary" style={{ marginLeft: '15%' }} /> : <NotInterestedIcon color="primary" style={{ marginLeft: '15%' }} />}
                                    </div>
                                </Tooltip>
                            </ListItem>
                        </Grid>
                        <Grid style={{ width: '6%', paddingLeft: '0%' }} onClick={() => { changeRol(row) }}>
                            <ListItem button >
                                <Tooltip title="cambiar rol" aria-label="right-end" ref={tooltipRef}>
                                    <div>
                                        <GiCardExchange className="iconostable" style={{ marginLeft: '15%', color: primaryColor }} />
                                    </div>
                                </Tooltip>
                            </ListItem>
                        </Grid>
                        <Grid style={{ width: '6%', paddingLeft: '0%' }} onClick={() => { changeMachine(row) }}>
                            <ListItem button >
                                <Tooltip title="Asignar Estacion" aria-label="right-end" ref={tooltipRef}>
                                    <div>
                                        <CalendarViewDayIcon color="primary" style={{ marginLeft: '15%' }} />
                                    </div>
                                </Tooltip>
                            </ListItem>
                        </Grid>


                    </Grid>
                </Paper>
            ))}
        </>
    );


}